export default __webpack_public_path__ + "static/media/contactless-card.ef3f3782.svg";